function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_971",
  "data-name": "Path 971",
  d: "M74.87,21.468V7.3a7.3,7.3,0,0,0-7.3-7.3H16.435a7.3,7.3,0,0,0-7.3,7.3V43.381a9.586,9.586,0,0,0,0,19.151V76.7a7.3,7.3,0,0,0,7.3,7.3h51.13a7.3,7.3,0,0,0,7.3-7.3V40.619a9.586,9.586,0,0,0,0-19.151ZM2.739,52.957a6.855,6.855,0,0,1,6.391-6.831V59.787A6.856,6.856,0,0,1,2.739,52.957ZM74.87,37.874V24.213a6.846,6.846,0,0,1,0,13.662Z",
  fill: "#f2efe2"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_972",
  "data-name": "Path 972",
  d: "M91.826,132.152a1.37,1.37,0,0,1,1.37-1.37H109.63a1.37,1.37,0,1,1,0,2.739H93.2A1.37,1.37,0,0,1,91.826,132.152Zm52.5,36.978H127.891a1.37,1.37,0,1,0,0,2.739h16.435a1.37,1.37,0,0,0,0-2.739Zm-32.87-12.783H93.2a1.37,1.37,0,1,0,0,2.739h18.261a1.37,1.37,0,1,0,0-2.739Zm32.87,0H127.891a1.37,1.37,0,1,0,0,2.739h16.435a1.37,1.37,0,0,0,0-2.739Zm-34.239-11.413a1.37,1.37,0,0,0,1.37,1.37h32.87a1.37,1.37,0,1,0,0-2.739h-32.87A1.37,1.37,0,0,0,110.087,144.934ZM93.2,146.3h7.3a1.37,1.37,0,1,0,0-2.739H93.2a1.37,1.37,0,1,0,0,2.739Zm12.6-2.739a1.37,1.37,0,1,0,0,2.739h.183a1.37,1.37,0,1,0,0-2.739Zm11.322,12.783h-.183a1.37,1.37,0,1,0,0,2.739h.183a1.37,1.37,0,0,0,0-2.739Zm5.3,0h-.183a1.37,1.37,0,1,0,0,2.739h.183a1.37,1.37,0,1,0,0-2.739Z",
  transform: "translate(-76.761 -109.326)",
  fill: "#e60f64"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_973",
  "data-name": "Path 973",
  d: "M43.291,143.675l-7.1,5.6a1.093,1.093,0,0,1-1.291,0,.654.654,0,0,1-.267-.509v-4.744H9.587a9.587,9.587,0,0,1-.457-19.162v2.744a6.847,6.847,0,0,0,.456,13.679H34.631v-4.744a.654.654,0,0,1,.267-.509,1.093,1.093,0,0,1,1.291,0l7.1,5.6A1.238,1.238,0,0,1,43.291,143.675Zm31.122-40.736H49.3V98.194a.654.654,0,0,0-.267-.509,1.093,1.093,0,0,0-1.291,0l-7.1,5.6a1.238,1.238,0,0,0,0,2.038l7.1,5.6a1.093,1.093,0,0,0,1.291,0,.654.654,0,0,0,.267-.509v-4.744H74.413a6.847,6.847,0,0,1,.456,13.679V122.1a9.587,9.587,0,0,0-.456-19.162Z",
  transform: "translate(0 -81.482)",
  fill: "#004fd4"
});

var SvgContentUpdate = function SvgContentUpdate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "content_1_",
    "data-name": "content (1)",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgContentUpdate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/content-update.e4520768.svg";
export { ForwardRef as ReactComponent };